import { Component } from '@angular/core';

@Component({
    selector: 'lokos-card',
    templateUrl: './card.component.html',
    styleUrl: './card.component.scss',
    standalone: false,
})
export class CardComponent {}
